import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import download from 'downloadjs';
import sanitize from 'lib/sanitize';
import errorCodes from 'client/errorCodes';
import {setUpStore} from 'client/framework';
import {addToast, addGenericErrorToast} from '@albert-io/atomic';
import {genericMandarkRequest} from 'resources/mandark.resource';
import Button from 'sg/Button/Button.react';
import SettingsTableStore from 'sg/Tables/SettingsTable/SettingsTable.store';

export default class DownloadCSV extends React.Component {
  static propTypes = {
    csvQuery: PropTypes.func,
    tableStoreName: PropTypes.string,
    fileName: PropTypes.string,
    getCSVHeaders: PropTypes.func
  };

  static defaultProps = {
    getCSVHeaders: () => {}
  };

  constructor() {
    super();
    this.state = {
      pendingDownload: false
    };
  }

  getSettingsTableStore() {
    return setUpStore(SettingsTableStore, this.props.tableStoreName);
  }

  downloadCSV = () => {
    this.setState({pendingDownload: true});
    const visibleColumns = this.getSettingsTableStore().getVisibleColumns();
    const headers = this.props.getCSVHeaders(visibleColumns);
    const csvQuery = this.props.csvQuery(headers);
    genericMandarkRequest('get', csvQuery, null, {raw: true})
      .then((res) => {
        download(
          res.text,
          `${sanitize.filename(`${this.props.fileName}-${moment().format('YYYY-MM-DD')}`)}.csv`,
          'text/csv'
        );
      })
      .catch((e) => {
        logger.error(`Failed to download usage report CSV: %s`, e.message || 'unknown error');
        if (e?.message === errorCodes.BAD_REQUEST.TIMEOUT) {
          addToast({
            type: 'danger',
            title: 'Something went wrong',
            message:
              'The server took too long to respond. Please try again. If the problem persists, contact us.'
          });
          return;
        }
        addGenericErrorToast();
      })
      .finally(() => {
        this.setState({pendingDownload: false});
      });
  };

  render() {
    const buttonText = this.state.pendingDownload ? 'Downloading...' : 'Download CSV';
    return (
      <Button
        text={buttonText}
        className='download-csv__button unbutton'
        onClick={this.downloadCSV}
        disabled={this.state.pendingDownload}
      />
    );
  }
}
